
import React, { useEffect } from "react";
import HeroSection from "./careers/hero-section";
import CultureSection from "./careers/culture-section";
import BenefitsSection from "./careers/benefits-section";
import JobListingSection from "./careers/job-listing-section";
import CTASection from "./careers/cta-section";

const Jobs = () => {

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
      <HeroSection />
      <CultureSection />
      <BenefitsSection />
      <JobListingSection />
      <CTASection />
    </>
  );
};

export default Jobs;
